// @ts-check

const ViewDistributedPosts = () => {
    return 0;
}

export default ViewDistributedPosts;